export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function parseEnum(values) {
    var list = [
        { text: '', value: ''}
    ]
      Object.values(values).forEach(function (value) {
            list.push(
                { text: value.replace('_', ' '), value: value}
            );
       })
    return list;
}

export function handleErrors(data) {
  let errors = data.response.data.errors
  let list   = []

  Object.keys(errors).forEach(function (key) {
    list.push(key + '  ' + errors[key])
  })

  return list;
}

export function empty(value) {
  if ('undefined' == value) {
    return true;
  }

  if ('' == value) {
    return true;
  }

  if (null == value) {
    return true;
  }

  return false;
}
